import { useQueryClient } from "@tanstack/react-query"
import { keys } from "../../api/keys"
import { useAction } from "../../hooks/useAction"

/**
 * Запись в карточку группы.
 *
 * Это `useAction` с одним дополнением: после успеха сбрасывается всё, чего
 * правка могла коснуться. Любое изменение задевает и саму группу
 * (`attributesColumnOrder` лежит в ней), и табличную часть, поэтому обновляем
 * обе, а заодно список групп — в нём видны название и галки.
 */
export function useWriter(groupId: string | undefined) {
	const client = useQueryClient()

	return useAction({
		after: () =>
			Promise.all([
				client.invalidateQueries({ queryKey: keys.group(groupId) }),
				client.invalidateQueries({ queryKey: keys.groupRows(groupId) }),
				client.invalidateQueries({ queryKey: keys.groupCategories(groupId) }),
				client.invalidateQueries({ queryKey: keys.freeProducts() }),
				client.invalidateQueries({ queryKey: keys.groups() }),
				// состав набора: правка товара карточки не трогает его, но правка
				// самого состава идёт этим же писателем — дешевле сбросить оба
				// ключа всегда, чем заводить второй useWriter только под них
				client.invalidateQueries({ queryKey: keys.toolsetProducts(groupId) }),
				client.invalidateQueries({
					queryKey: keys.possibleToolsetProducts(groupId),
				}),
			]),
	})
}
